import React from "react";
import axios from "axios";
import { login as API_LOGIN } from "./config/api";
import { sys as API_SYS } from "./config/api";
import { setup as URI_SETUP } from "./config/api";
import Login from "./Login";
//Componentes
import Header from "./components/Header";
import SidebarLeft from "./components/SidebarLeft";
import SidebarNotifications from "./components/SidebarNotifications";

//Layouts
import LayoutAccount from "./modules/account/Layout.js";
import LayoutSetup from "./modules/setup/Layout.js";
import LayoutSupport from "./modules/support/Layout.js";
import LayoutLegal from "./modules/legal/Layout.js";

const postUrlLogin = API_LOGIN;
const sysUrl = API_SYS;
const uri_notifications = URI_SETUP+"notifications";
const uri_hotels = URI_SETUP+"hotel";
const uri_data_source_csv = URI_SETUP+"data_source/csv/schema";
const uri_catalogs = URI_SETUP+"catalog";

class SetupApp extends React.Component{
  
  constructor(props){
    super(props);
    this.state = {
      first_request             : true,
      isVisible                 : "loading-wait",
      layout_active             : "setup",
      section_active            : "seasons",
      hotel_selected            : "",
      status_sb_notifications   : "",
      is_login                  : true,
      sys_catalogs              : [],
      sys_tree                  : [],
      hotels                    : [],
      parsing_schema_list       : [],
      lst_notifications         : [],
      lst_tmp_notifications     : [],
      lst_seasons               : [],
      item_active               : ""
    }
    this.setSession = this.setSession.bind(this);
    this.activeSection = this.activeSection.bind(this);
    this.refreshCatalogSys = this.refreshCatalogSys.bind(this);
    this.getHotels = this.getHotels.bind(this);
    this.setActiveHotel = this.setActiveHotel.bind(this);
    this.renderSelectHotels = this.renderSelectHotels.bind(this);
    this.handleStatusNotifications = this.handleStatusNotifications.bind(this);
    this.openStatusNotifications = this.openStatusNotifications.bind(this);
    this.handleNotification = this.handleNotification.bind(this);
  }
  
  componentWillMount(){
    this.verifyToken();
    this.sysStartup();
    this.getHotels();
    this.setActiveHotel('5bb6939b712c984a346d8cf3'); //tmp
    this.loadNotificationQueue();
  }

  componentDidMount(){
    
  }

  loadNotificationQueue(){
    let self = this;
    axios.get(uri_notifications, { 
        params: {
            api_token   : localStorage.getItem("api_token")
        }
    }).then(request => {
        self.setState({ 
          lst_notifications     : request.data
        }) 
    })
  }

  sysStartup() {
    let self = this;
    axios.get(sysUrl+"startup", { 
        params: {
            api_token   : localStorage.getItem("api_token")
        }
    }).then(request => {
        self.setState({ 
          sys_catalogs          : request.data.catalogs,
          sys_tree              : request.data.tree
        }) 
    })

  }

  getSeasons(){
    let self = this;
    axios.get(uri_catalogs+"/season", { 
        params: {
            api_token           : localStorage.getItem("api_token"),
            property_id         : self.state.hotel_selected,
        }
    }).then(request => { 
        if(request.data.length>0){
            self.setState({ 
                lst_seasons             : request.data
                }) 
        }else{
            self.setState({ 
                catalog_items_found             : []
                }) 
        }

        
        
    })
}

  handleNotification(type,action,msg,key){
    if(type=="tmp"){

      const lst_tmp_notifications = this.state.lst_tmp_notifications;
      this.openStatusNotifications();
      
      switch(action){
        case 'new':
          lst_tmp_notifications.push(msg);
          key=lst_tmp_notifications.length-1;
          break;
        case 'update':
          lst_tmp_notifications[key]=msg;
          break;
        case 'remove':
          lst_tmp_notifications.splice(key, 1);
          break;
      }

      this.setState({
        lst_tmp_notifications
      });

    }else{

      switch(action){
        case 'remove':
          axios.post(uri_notifications+"/"+key+"/destroy")
              .then(request => {
                  this.loadNotificationQueue();   
          })

          break;
      }

    }
    
    return key;
    
  }

  refreshCatalogSys($property_id) {
    let self = this;

    axios.get(sysUrl+"catalog", { 
        params: {
            api_token   : localStorage.getItem("api_token"),
            property_id : $property_id
        }
    }).then(request => {
        self.setState({ 
          sys_catalogs          : request.data
        }) 
    })

  }

  activeSection(layout,section,hotel_selected,item_active){
    let self = this;
    self.setState({
      layout_active : layout,
      section_active : section,
      hotel_selected : hotel_selected,
      item_active    : item_active
    })
  }
  setSession(state){
    let self = this;
    self.setState({
      is_login : state,      
    })
  }
  verifyToken(){
    let self = this;
    if(self.state.isVisible === "loading-wait"){
      let data = {
        api_token : localStorage.getItem("api_token")
      };
      let qs = require("qs");
      axios.post(postUrlLogin, qs.stringify(data))
      .then(function (response) {
          if ( response.data["status"] === "error" ){
              localStorage.removeItem("api_token");
              localStorage.removeItem("name");
              localStorage.removeItem("email");
              self.setState({
                is_login : false,
                first_request : true
              })
          }else{
            self.setState({
              is_login : true,
              isVisible : "",
            }, function(){
              setTimeout(() => {
                self.setState({
                  isVisible: "loading-success",
                  first_request : false
                })
              }, 1000);
            })
          }
      })
      .catch(function (error) {
      });
    }
  }

  handleStatusNotifications(){
    let sbn_status="";
    sbn_status=(this.state.status_sb_notifications==="")?"open":"";
    this.setState({ 
      status_sb_notifications : sbn_status
      }) 
  }

  openStatusNotifications(){
    
    this.setState({ 
      status_sb_notifications : "open"
      }) 
  }

  handleHotelChange = (event) => {
    this.setActiveHotel(event.target.value);
  };

  setActiveHotel(hotel){
    hotel= (hotel==='')? this.state.hotel_selected : hotel;
    let self = this;
    axios.get(uri_data_source_csv, { 
      params: {
          api_token   : localStorage.getItem("api_token"),
          property    : hotel
      }
    }).then(request => { 
        self.setState({ 
            parsing_schema_list : request.data,
            hotel_selected : hotel 

            }) 
        }) 
    
    self.getSeasons();
    
  }

  getHotels() {
    let self = this;
    axios.get(uri_hotels, { 
        params: {
            api_token   : localStorage.getItem("api_token")
        }
    }).then(request => { 
        self.setState({ 
        hotels                  : request.data
        }) 
    })
  } 


  renderSelectHotels() {
    return  <select className="form-control top-form-select " name="hotel_id" value={this.state.hotel_selected}  onChange={this.handleHotelChange.bind(this)}  >
                <option disabled>HOTEL</option>
                {Object.keys(this.state.hotels).map((key, index) => {
                    return ( <option value={this.state.hotels[key]._id} key={index}> {this.state.hotels[key].name}</option>);
                    })
                }
            </select> 
  }
  
  render(){
    if(this.state.is_login){
      return(
        <div className="container-general">
            <div className={ "loading-general " + this.state.isVisible }>
              <span></span>
            </div>
            <Header
              setSession={this.setSession}
            />
            <main className="container-fluid main-container">
              <SidebarLeft
                setSession={this.setSession}
                activeSection={this.activeSection}
                setActiveHotel = {this.setActiveHotel}
                menu={this.state.sys_tree}
                hotels={this.state.hotels}
                app={this}
              />
              <div className="content">
                <div className={"account " + (this.state.layout_active !== "account" ? "hide" : "") }>
                  
                </div>
                <div className={"setup " + (this.state.layout_active !== "setup" ? "hide" : "") }>
                  <LayoutSetup
                    catalogs={this.state.sys_catalogs}
                    refreshCatalogSys={this.refreshCatalogSys}
                    setActiveHotel = {this.setActiveHotel}
                    getHotels = {this.getHotels}
                    renderSelectHotels = {this.renderSelectHotels}
                    openStatusNotifications={this.openStatusNotifications}
                    activeSection={this.activeSection}
                    handleNotification={this.handleNotification}
                    app={this}
                    hotel_selected = {this.state.hotel_selected}
                    item_active = {this.state.item_active}
                  />
                </div>
                <div className={"support " + (this.state.layout_active !== "support" ? "hide" : "") }>
                  <LayoutSupport
                    //app={this}
                  />
                </div>
                <div className={"legal " + (this.state.layout_active !== "legal" ? "hide" : "") }>
                  <LayoutLegal
                    //app={this}
                  />
                </div>


              </div>
              <SidebarNotifications
                handleStatusNotifications={this.handleStatusNotifications}
                handleNotification = {this.handleNotification}
                lst_tmp_notifications={this.state.lst_tmp_notifications}
                lst_notifications={this.state.lst_notifications}
                app={this}
              />
          

            </main>
            
        </div>
      )
    }else{
      return (
        <div>
          <Login 
            setSession={this.setSession}
          />
        </div>
      )
    }
  }
};
export default SetupApp


// WEBPACK FOOTER //
// ./src/Setup/App.js